export enum OidcAuthenticationConfig {
  SelfService = "step-up",
  Default = "auth",
}
